import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.502 9.332q1.346 0 2.285-.942.94-.941.94-2.288t-.941-2.285-2.288-.94-2.286.941-.94 2.288q0 1.346.942 2.286.941.94 2.288.94M8.5 8.242a2.06 2.06 0 0 1-1.514-.624 2.06 2.06 0 0 1-.624-1.514q0-.89.624-1.514.623-.623 1.514-.623.89 0 1.514.623.624.624.623 1.514 0 .891-.623 1.514-.623.624-1.514.624m0 3.404q-2.73 0-4.975-1.507Q1.279 8.633.218 6.104 1.28 3.576 3.523 2.07A8.74 8.74 0 0 1 8.5.563q2.73 0 4.976 1.506t3.307 4.035q-1.062 2.529-3.306 4.035a8.73 8.73 0 0 1-4.975 1.507m0-1.188q2.236 0 4.107-1.177a7.74 7.74 0 0 0 2.86-3.177 7.74 7.74 0 0 0-2.86-3.176A7.56 7.56 0 0 0 8.5 1.75q-2.236 0-4.107 1.178a7.74 7.74 0 0 0-2.86 3.176 7.74 7.74 0 0 0 2.86 3.177A7.56 7.56 0 0 0 8.5 10.458"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
